module.exports = __webpack_public_path__ + "img/dashboard-logs.82a21b6e.png";